<template lang="pug">

  
  #cepi-app
    v-overlay(:value='overlay')
      v-progress-circular(indeterminate='' size='64')

    router-view
      router-view(name='main' @loadingEvent='loadingStatus')



</template>


<script>
export default {
  name: 'App',
  data: () => ({
    overlay: false
  }),
  methods:{
    loadingStatus(loading){
      console.log('Loading...', loading)
      this.overlay = loading;
    }
  }
};
</script>
